// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.file-type_tip[data-v-14309e06]{font-size:12px; color:#909399; line-height:1em;}\n.btn-sf-del[data-v-14309e06]{cursor:pointer;}\n.btn-sf-del[data-v-14309e06]:hover{color:red;}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
